var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergyService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3C26.2842 3 33 9.71572 33 18C33 26.2842 26.2842 33 18 33C9.71572 33 3 26.2842 3 18C3 9.71572 9.71572 3 18 3ZM16.8633 14.2427C16.2291 13.8199 15.3781 13.9391 14.8857 14.521L9.65625 20.7012C9.1398 21.312 9.81117 22.1995 10.5396 21.8686L15.3706 19.6728C15.6066 19.5655 15.8814 19.5876 16.0971 19.7314L19.1367 21.7574C19.7709 22.1802 20.6218 22.0609 21.1143 21.479L26.3438 15.2988C26.8602 14.688 26.1888 13.8005 25.4604 14.1314L20.6294 16.3272C20.3934 16.4345 20.1186 16.4124 19.9029 16.2686L16.8633 14.2427Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyService);
export default __webpack_public_path__ + "static/media/energy-service.5c6addd71b8d3a8672ab69eb1ad9f4c5.svg";
export { ForwardRef as ReactComponent };